import FooterHeroSection from '#app/components/Landing-page/footer-section'
import { TERMS_OF_SERVICE_HTML } from '#app/data/terms-content'

export default function TermsOfServiceRoute() {
	return (
		<div className="w-full min-h-screen overflow-hidden">
			<section className="py-12 sm:py-16 lg:py-24">
				<div className="px-[15px] md:px-[100px] mx-auto">
					<div
						className="terms-content prose prose-sm max-w-none"
						dangerouslySetInnerHTML={{ __html: TERMS_OF_SERVICE_HTML }}
					/>

					<div className="text-center mt-12">
						<a
							href="/"
							className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-['Futura_Md_BT'] text-lg"
						>
							← Back to Home
						</a>
					</div>
				</div>
			</section>
			<FooterHeroSection />
		</div>
	)
}
